var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "m-3" },
    [
      !_vm.loaded
        ? [_vm._m(0)]
        : !_vm.error
        ? [
            _c("h4", { staticClass: "modal-title d-inline-block" }, [
              _c("b", [_vm._v(_vm._s(_vm.card.name))])
            ]),
            _vm._v(" "),
            _c("small", { staticClass: "idcontainer" }, [
              _vm._v("ID " + _vm._s(_vm.card.id.split("-").slice(-1)[0]))
            ]),
            _vm._v(" "),
            _c("small", { staticClass: "idcontainer" }, [
              _vm._v(" - " + _vm._s(_vm.flow.name))
            ]),
            _vm._v(" "),
            _vm.loaded
              ? _c("DetailsContent", {
                  attrs: {
                    readonly: true,
                    state: _vm.state,
                    board: _vm.board,
                    flow: _vm.flow,
                    card: _vm.card
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.hasOneEditableVueForm
              ? [
                  _c("VueFormAttribute", {
                    attrs: {
                      definition: _vm.editableVueFormDefinition,
                      attribute: _vm.editableVueFormAttribute
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary mt-2 ml-auto d-print-none",
                        on: { click: _vm.saveVueForm }
                      },
                      [_vm._v(_vm._s(_vm.$t("btnSave")))]
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary btn-sm d-print-none",
                on: { click: _vm.printScreen }
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("btnPrint")) + "\n    ")]
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "alert alert-danger", attrs: { role: "alert" } },
              [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }